import { z } from 'zod'

export type RecentSpendListFormValues = z.infer<
  typeof RecentSpendListFormSchema
>

export const RecentSpendListFormSchema = z.object({
  name: z.string().min(1, { message: 'List name is required' }),
  minimumMinutes: z.coerce.number().int('Please enter a valid number').min(1, {
    message: 'Minimum 1 minute for custom recent spenders list',
  }),
})
